import React from "react";
import "./welcome-new.scss";
import { withRouter } from "react-router";
import InnerShadowButton from "../../common/buttons/innerShadow";

class WelcomeNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      device: "mobile"
    };
    window.scrollTo(0, 0);
  }
  moveToProducts() {
    if (this.state.device === "web") {
      window.scrollTo(0, 839);
    } else {
      window.scrollTo(0, 825);
    }
  }
  componentDidMount() {
    this.setState({
      device: window.screen.availWidth < 850 ? "mobile" : "web"
    });
  }

  getImageCol() {
    return (
      <img
        className={"bg-image"}
        src={require("../../../assets/images/landing/family-group.png")}
        alt=""
      />
    );
  }
  getTextCol() {
    return (
      <div lg="8" className="m-0 p-0 left-col">
        <h1 className={"title-1 mb-40 mb-mobile-27"}>
          The all-in-one insurance plan for everyone
        </h1>
        <hr className="mobile-only mt-0 mb-mobile-21" />
        <h3 className="title-2 mb-48 mb-mobile-18 ">
          Your most important insurance needs are met with a single Toffee
          insurance plan. Get all the convenience of{" "}
          <span className="font-weight-bold">
            health insurance, life insurance and insurance for your household{" "}
          </span>
          in just one combo-plan.{" "}
          <span className="m-hide font-weight-bold">{"\n"}Easy as A-B-C!</span>
        </h3>
        <hr className="mobile-only mt-0 mb-mobile-23" />
        <div className="d-flex align-items-center justify-content-center  btn-container">
          <h3 className="mobile-only m-0 mr-16 font-weight-bold">
            Easy as A-B-C!
          </h3>

          <InnerShadowButton
            clicked={e => {
              this.moveToProducts();
            }}
            title="See Plans"
            active={true}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="welcome-container-new">
        <img
          className="logo"
          src={require("../../../assets/images/landing/logo.png")}
          alt=""
        />
        {this.getTextCol()}
        {this.getImageCol()}
        {/* </div> */}
      </div>
    );
  }
}

export default withRouter(WelcomeNew);
